<template>
  <div id="app">
    <index></index>
  </div>
</template>
<script>
    import Index from './views/Index'
    export default {
        components:{
            Index
        }
    }
</script>
<style lang="less">
  @import url('~@/assets/css/reslove.css');
  html,body{
    width: 100%;
    height: 100%;
    overflow-y: hidden;
  }
  #app {
    width: 100%;
    height: 100%;
    background:url('./assets/image/背景3.png');
    min-width: 100rem;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }


</style>
